import {Map} from 'maplibre-gl';
import {MapContent} from './MapContent';
import { Protocol } from 'pmtiles';

export class EmptyMapContent implements MapContent {

  static instance = new EmptyMapContent();

  load(map: Map, protocol: Protocol, zoomToFeatures: boolean) {
  }

  unload() {
  }
}
